/**
 * Utility functions for consistent case status styling across components
 */

/**
 * Get consistent status color classes for case status
 * @param {string} status - The case status
 * @returns {string} Tailwind CSS classes for the status
 */
export const getStatusColor = (status) => {
  switch (status?.toLowerCase()) {
    case 'closed':
      return 'bg-gray-100 text-gray-600 border-gray-200';
    case 'open':
      return 'bg-blue-100 text-blue-800 border-blue-200';
    case 'pending':
      return 'bg-yellow-100 text-yellow-800 border-yellow-200';
    case 'sentenced':
      return 'bg-blue-100 text-blue-800 border-blue-200';
    case 'dismissed':
      return 'bg-gray-100 text-gray-800 border-gray-200';
    default:
      return 'bg-gray-100 text-gray-600 border-gray-200';
  }
};

/**
 * Get status color classes without border (for components that don't use borders)
 * @param {string} status - The case status
 * @returns {string} Tailwind CSS classes for the status
 */
export const getStatusColorNoBorder = (status) => {
  switch (status?.toLowerCase()) {
    case 'closed':
      return 'bg-gray-100 text-gray-600';
    case 'open':
      return 'bg-blue-100 text-blue-800';
    case 'pending':
      return 'bg-yellow-100 text-yellow-800';
    case 'sentenced':
      return 'bg-blue-100 text-blue-800';
    case 'dismissed':
      return 'bg-gray-100 text-gray-800';
    default:
      return 'bg-gray-100 text-gray-600';
  }
};

/**
 * Check if a case status is considered "closed"
 * @param {string} status - The case status
 * @returns {boolean} True if the status is closed
 */
export const isCaseClosed = (status) => {
  return status?.toLowerCase() === 'closed';
};
